
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import './App.css';

import Landing from './views/landing';
import Booking from './views/booking';
// import Term from './components/legal/term';
// import Privacy from './components/legal/privacy';
import Nav from './views/nav';
import Footer from './views/footer';
import Portfolio from './views/portfolio';
import Review from './views/review';
import About from './views/about';
import Contact from './views/contact';

const router = createBrowserRouter ([
  {
    path: "/",
    element: <><Landing/>
              <About/>
              <Portfolio/>
              <Review/>
              <Contact/>
              </>
  },
  {
    path: "/booking",
    element: <Booking/>
    
  },

]);

function App() {

  return (
    <div className="App">
      <Nav/>
      <RouterProvider router = {router} />   
      <Footer/>
    </div>
  );
}

export default App;
